import { gql, useQuery } from '@apollo/client'

import {
  ConsoleAccountSettingQuery,
  ConsoleAccountSettingQueryVariables,
} from '@/clients/utoniq-core/schema'
import { makeViewModel } from '@/core/architecture'
import { useCurrentUser } from '@/core/auth'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { user } = useCurrentUser()
  const { data } = useQuery<
    ConsoleAccountSettingQuery,
    ConsoleAccountSettingQueryVariables
  >(QUERY, {
    variables: {
      artistId: user?.uid,
    },
  })

  return {
    state: {
      user,
      artistId: user?.uid ?? '',
      currentUser: user ?? null,
      paymentType: data?.artist?.paymentType ?? null,
      hasArrangingDeliveryItems: data?.artist?.hasArrangingDeliveryItems,
      membership: data?.artist?.subscription?.products ?? undefined,
    },
    actions: {},
  }
})

const QUERY = gql`
  query ConsoleAccountSetting($artistId: ID) {
    artist(id: $artistId) {
      id
      paymentType
      hasArrangingDeliveryItems
      subscription {
        products {
          productId
        }
      }
    }
  }
`
